import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import Button from '@v2/shared/components/Button';

/** Where both flows end, whichever branch of them the customer took. */
export default function SuccessStep({ message, onClose }: { message: string; onClose: () => void }) {
  return (
    <div className="p-5 md:p-8 text-center">
      <div className="mb-6">
        <FontAwesomeIcon icon={faCheckCircle} className="text-green-600 text-6xl mb-4" />
        <h2 className="font-semibold text-2xl mb-4 tracking-tight text-green-800">Success!</h2>
        <p className="text-gray-700 text-lg leading-relaxed">{message}</p>
      </div>

      <div className="flex justify-center">
        <Button onClick={onClose} className="text-sm">
          Close
        </Button>
      </div>
    </div>
  );
}
